import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
  tone?: "paper" | "velvet";
  className?: string;
}

/**
 * Базовая editorial-подложка экрана. Paper = светлая, Velvet = тёмная драма.
 * Содержит subtle radial-оверлеи для премиального ощущения.
 */
export function Screen({ children, tone = "paper", className = "" }: Props) {
  const isVelvet = tone === "velvet";
  return (
    <div
      data-screen
      className={`relative min-h-[100dvh] overflow-hidden ${
        isVelvet ? "bg-velvet-night text-[#eae4f3]" : "bg-paper text-ink"
      } ${className}`}
    >
      {!isVelvet && (
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0"
          style={{
            background:
              "radial-gradient(circle at 82% 88%, rgba(124,75,255,0.09), transparent 48%), radial-gradient(circle at 12% 10%, rgba(194,50,40,0.05), transparent 55%)",
          }}
        />
      )}
      <div
        className="relative z-10 flex min-h-[100dvh] flex-col"
        style={{
          paddingTop: "env(safe-area-inset-top)",
          paddingBottom: "env(safe-area-inset-bottom)",
        }}
      >
        {children}
      </div>
    </div>
  );
}
